import * as w from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { transformColor as n } from "../../utilities/transformations.js";
import { grain as A } from "../../helpers/grain.js";
import { getAspectCorrectedCoordinates as T } from "../../utilities/uv.js";
const U = {
  name: "Whisper5",
  collection: "whisper",
  tags: ["wave", "gradient", "soft"],
  props: {
    colorA: {
      type: String,
      default: "#3CBBB1",
      transform: n,
      description: "The primary color of the light."
    },
    colorB: {
      type: String,
      default: "#5353b5",
      transform: n,
      description: "An accent color."
    },
    backgroundColor: {
      type: String,
      default: "#493697",
      transform: n,
      description: "The background color."
    },
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the light waves."
    }
  },
  fragmentNode: (o) => {
    const {
      vec4: e,
      uv: d,
      time: c,
      sin: u,
      cos: s,
      mix: t,
      abs: p,
      smoothstep: f,
      oneMinus: g
    } = w, r = d(), h = u(s(
      r.y.mul(Math.PI * 2).add(c.mul(o.speed.uniform).mul(0.2))
    ).mul(0.3).mul(s(c.mul(0.3)))).add(0.5), b = t(
      o.colorA.uniform,
      o.colorB.uniform,
      r.y
    ), C = p(r.x.sub(h)), l = f(
      0.6,
      0,
      C
    ), a = t(
      o.backgroundColor.uniform.mul(2),
      o.backgroundColor.uniform.mul(0.5),
      g(r.y)
    ), { correctedUV: y } = T(), B = A(0.8)(y), k = b.mul(l).mul(1).sub(B.mul(1)), v = ((i = e(0), m = e(0)) => i.add(m).sub(i.mul(m)))(a, k);
    return e(
      t(
        a,
        v,
        l
      ),
      1
    );
  }
};
export {
  U as componentDefinition,
  U as default
};
